import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** August 2025 toolkit */
export const familyToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.FAMILY,
  iFrameSrcUrl: '/family',
  micrositeUrl: 'family',
  title: {
    id: 'familyToolkit.title',
    defaultMessage: 'Care for the whole family',
    description: 'Microsite page title',
  },
  featureFlag: 'isAugustFamilyToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/parenting-in-the-real-world',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: '202508 family',
  trackUTMParams: {
    utm_campaign: 'family202508',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'family',
  },
  shouldHideForInternational: true,
}
